import initialStates from '../../initialStates';
import {
    COST_ACCOUNTING_ACTION_FAILURE,
    COST_ACCOUNTING_ACTION_REQUEST,
    COST_ACCOUNTING_ACTION_SUCCESS,
    FETCH_COST_ACCOUNTING_AUDIT_FAILURE,
    FETCH_COST_ACCOUNTING_AUDIT_REQUEST,
    FETCH_COST_ACCOUNTING_AUDIT_SUCCESS,
    FETCH_COST_ACCOUNTING_ENTRIES_FAILURE,
    FETCH_COST_ACCOUNTING_ENTRIES_REQUEST,
    FETCH_COST_ACCOUNTING_ENTRIES_SUCCESS,
    FETCH_COST_ACCOUNTING_PERIODS_FAILURE,
    FETCH_COST_ACCOUNTING_PERIODS_REQUEST,
    FETCH_COST_ACCOUNTING_PERIODS_SUCCESS,
    FETCH_COST_ACCOUNTING_PROFITABILITY_FAILURE,
    FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST,
    FETCH_COST_ACCOUNTING_PROFITABILITY_SUCCESS,
} from './costAccounting-actions';

const costAccountingReducer = (state = initialStates.costAccounting, action) => {
    switch (action.type) {
    case FETCH_COST_ACCOUNTING_PERIODS_REQUEST:
    case FETCH_COST_ACCOUNTING_AUDIT_REQUEST:
        return { ...state, isLoading: true, auditFetchKey: action.auditFetchKey || state.auditFetchKey };
    case FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST:
    case COST_ACCOUNTING_ACTION_REQUEST:
        return { ...state, isLoading: true };
    case FETCH_COST_ACCOUNTING_ENTRIES_REQUEST:
        return {
            ...state,
            isLoading: true,
            entriesFetchKey: `${action.periodUuid}:${action.state}:${action.sourceType || ''}:${action.sourceId || ''}:${action.page}`,
        };
    case FETCH_COST_ACCOUNTING_PERIODS_SUCCESS:
        return {
            ...state,
            isLoading: false,
            periods: action.data.content || [],
            periodsForwardSeekMap: action.data.forwardSeekMap || null,
            periodsBackwardSeekMap: action.data.backwardSeekMap || null,
            periodsFirst: action.data.first,
            periodsLast: action.data.last,
            periodsPage: action.page,
            periodsSize: action.size,
        };
    case FETCH_COST_ACCOUNTING_ENTRIES_SUCCESS: {
        const fetchKey = `${action.periodUuid}:${action.state}:${action.sourceType || ''}:${action.sourceId || ''}:${action.page}`;
        if (fetchKey !== state.entriesFetchKey) {
            return { ...state, isLoading: false };
        }
        return {
            ...state,
            isLoading: false,
            entries: action.data.content || [],
            forwardSeekMap: action.data.forwardSeekMap || null,
            backwardSeekMap: action.data.backwardSeekMap || null,
            entriesFirst: action.data.first,
            entriesLast: action.data.last,
            entriesPage: action.page,
            entriesSize: action.size,
        };
    }
    case FETCH_COST_ACCOUNTING_AUDIT_SUCCESS: {
        if (action.auditFetchKey && action.auditFetchKey !== state.auditFetchKey) {
            return { ...state, isLoading: false };
        }
        return {
            ...state,
            isLoading: false,
            auditEvents: action.data.content || [],
            auditForwardSeekMap: action.data.forwardSeekMap || null,
            auditBackwardSeekMap: action.data.backwardSeekMap || null,
            auditFirst: action.data.first,
            auditLast: action.data.last,
            auditPage: action.page,
            auditSize: action.size,
            auditFetchKey: action.auditFetchKey,
        };
    }
    case FETCH_COST_ACCOUNTING_PROFITABILITY_SUCCESS:
        return { ...state, isLoading: false, profitability: action.data || [] };
    case COST_ACCOUNTING_ACTION_SUCCESS:
        return { ...state, isLoading: false, lastActionResult: action.data };
    case FETCH_COST_ACCOUNTING_PERIODS_FAILURE:
    case FETCH_COST_ACCOUNTING_ENTRIES_FAILURE:
    case FETCH_COST_ACCOUNTING_AUDIT_FAILURE:
    case FETCH_COST_ACCOUNTING_PROFITABILITY_FAILURE:
    case COST_ACCOUNTING_ACTION_FAILURE:
        return { ...state, isLoading: false };
    default:
        return state;
    }
};

export default costAccountingReducer;
